import $ from 'jquery';

export default function(controller) {

  // Hides or shows options if there is items inside
  var options_lists = $('.dropdown.options-list')

  console.info(options_lists.length)

  $.each(options_lists, (index, value) => {

  if ($(value).find('ul li').length == 0) {
      $(value).remove()
    }
  });

};
